import * as React from 'react'
import Milliseconds from '../../../helper/milliseconds'

interface Props {
    message?: {
        args: {
            count: number
            time: number
        }
    }
}

export default class Http extends React.PureComponent<Props> {
    render = () => {
        const { message } = this.props

        let intro = <p>We observed requests making calls to the Facebook Graph Event API.</p>
        if (message) {
            const { args } = message

            intro = (
                <p>
                    This Trace makes <strong>{args.count} calls</strong> to the Facebook Graph Event API that take{' '}
                    <Milliseconds value={args.time} />.
                </p>
            )
        }

        return (
            <div>
                {intro}
                <p>
                    Since this is a regular page visit (GET request), the Facebook tracking is responsible for slowing down the initial Time
                    to First Byte (TTFB) of your website. If this happens across all or many of your regular page visits this affects your
                    Core Web Vitals for a functionality that is non-essential for rendering.
                </p>

                <p>You should offload calls to the Facebook event API to a background job, or only do them in Ajax requests.</p>
            </div>
        )
    }
}
